import { useEffect, useState, useMemo } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import { BookOpen, Users, Target, Building } from 'lucide-react';

import { useClasseContext } from "../context/ClasseContext";
import { useUser } from "../context/UserContext";
import ListClass from "../components/VueAccueilProf/ListClass";
import ListGroupVueProf from "../components/VueAccueilProf/ListGroupVueProf";
import EtablissementView from "../components/VueAccueilProf/EtablissementView";
import { pageDArriveeGroupe } from "../utils/groupesDeBesoin";
function RootProf() {

    const navigate = useNavigate();
    const location = useLocation();

    const {user} = useUser();
    const [selectedClasseId, setSelectedClasseId] = useState(null);
    const [selectedGroupId, setSelectedGroupId] = useState(null);
    // Page d'arrivée d'un groupe : « creer », ou « eleves » pour un demi-groupe
    // vide, que ses profs composent d'abord (décision prof 2026-09-30).
    const [arriveeGroupe, setArriveeGroupe] = useState('creer');
    const [listClasses, setListClasses] = useState([])
    const [listGroupes, setListGroupes] = useState([])
    const [activeView, setActiveView] = useState('classes'); // 'classes' ou 'groupes'


    const {etablissementData, setEtablissementData} = useUser();


    const {setClasseNom, setGroupNom, setClassesGroup, setNomProf} =  useClasseContext()

   const stats = {
    classes: listClasses.length,
    groupes: listGroupes.length
  };

  useEffect(() => {

      if ( user.id) {

          if (etablissementData) {
            setEtablissementData(etablissementData)
                  // Trouver le professeur spécifique
             const professeur = etablissementData.professeurs.find(prof => prof.id === user.id);

                if (professeur) {
                  setNomProf(professeur.nom + ' ' + professeur.prenom)

                  // Récupérer ses classes attribuées
                  if (professeur.classes) {
                    const filteredClasses = etablissementData.classes.filter(classe =>
                      professeur.classes.includes(classe.id)
                    );
                    setListClasses(filteredClasses)
                  }

                 

                  // Récupérer ses groupes
                  if (professeur.groupes) {
                    const filteredGroupes = etablissementData.groupes.filter(groupe =>
                      professeur.groupes.includes(groupe.id)
                    )
                    setListGroupes(filteredGroupes)
                  }
                }
      }
  } }, [etablissementData, user, setEtablissementData, setNomProf]);


  
    useEffect(()=> {
      if(location.pathname ==='/'){
        setSelectedClasseId(null);
      }
    }, [location])

    useEffect(()=> {
      if(selectedClasseId){
        navigate(`/home/creer/${selectedClasseId}`)
      }
      else if(selectedGroupId){
        navigate(`/home/${arriveeGroupe}/${selectedGroupId}`)
      }
    },[selectedClasseId,navigate,selectedGroupId,arriveeGroupe])


    const handleRowClick = (item, type) => {
      if(!type){
      setSelectedClasseId(item.id);
      localStorage.setItem('groupeActive', '')
      localStorage.setItem('classeActive', item.nom)
      setGroupNom('')
      setClasseNom(item.nom)
    
      }
      else{
        setArriveeGroupe(pageDArriveeGroupe(item))
        setSelectedGroupId(item.id)
        localStorage.setItem('classeActive', '')
        localStorage.setItem('groupeActive',item.nom)
        setClassesGroup(item.classes_detail)
        setClasseNom('')
        setGroupNom(item.nom)
      }
    }
   const professeur = useMemo(() => {
  if (!etablissementData?.professeurs || !user?.id) return null;
  return etablissementData.professeurs.find(p => p.id === user.id) || null;
}, [etablissementData, user?.id]);

const isDelegueAffectation = !!professeur?.delegue_affectation;

const listClassesEtablissement = useMemo(() => {
  return etablissementData?.classes || [];
}, [etablissementData]);



    const classesVides = useMemo(
        () => listClassesEtablissement.filter(c => c.nombre_eleves === 0),
        [listClassesEtablissement]
    );

    // Style commun : onglet actif = gradient TanoEd bleu→cyan, comme le logo et l'avatar
    const tabActiveClass = 'bg-gradient-to-br from-blue-500 to-cyan-500 text-white shadow-md shadow-blue-500/30';
    const tabInactiveClass = 'text-slate-600 hover:text-slate-900 hover:bg-slate-50';

    return(

 <div className="flex-1 flex flex-col">
   <div className="flex-1 flex">
          <div className="flex-1 p-4 sm:p-6 md:p-8 xl:p-5 2xl:p-6 3xl:p-8">

            {/* Header — fond transparent, pas de card */}
            <div className="mb-6 xl:mb-4 2xl:mb-5 3xl:mb-6">
              <div className="px-1 py-1 sm:py-2">
                {/* Titre seul */}
                <div className="flex items-center gap-2.5 sm:gap-3 mb-4 sm:mb-5">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 xl:w-10 xl:h-10 2xl:w-11 2xl:h-11 3xl:w-12 3xl:h-12 rounded-xl sm:rounded-2xl bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center shadow-lg shadow-blue-500/30 flex-shrink-0">
                    <BookOpen className="w-5 h-5 sm:w-6 sm:h-6 xl:w-5 xl:h-5 2xl:w-5 2xl:h-5 3xl:w-6 3xl:h-6 text-white" />
                  </div>
                  <div>
                    <h1 className="text-slate-800 text-lg sm:text-xl xl:text-base 2xl:text-lg 3xl:text-xl font-bold">Mes Classes & Groupes</h1>
                    <p className="text-slate-400 text-xs sm:text-sm xl:text-xs 2xl:text-xs 3xl:text-sm">Gérez vos classes et groupes de besoins</p>
                  </div>
                </div>

                {/* Segmented centré sous le titre */}
                <div className="flex justify-center">
                  <div className="flex items-center gap-1 p-1 rounded-2xl bg-white border border-slate-200 shadow-sm">
                    {/* Onglet Classes */}
                    <button
                      onClick={() => setActiveView('classes')}
                      className={`relative flex items-center gap-2 px-4 py-2.5 rounded-xl text-[13px] font-semibold transition-all duration-200 ${
                        activeView === 'classes' ? tabActiveClass : tabInactiveClass
                      }`}
                    >
                      <Users className="w-4 h-4" />
                      <span>Classes</span>
                      <span className={`min-w-[22px] h-[22px] inline-flex items-center justify-center px-1.5 rounded-full text-[11px] font-bold transition ${
                        activeView === 'classes' ? 'bg-white/20 text-white' : 'bg-slate-100 text-slate-600'
                      }`}>
                        {stats.classes}
                      </span>
                    </button>

                    {/* Onglet Groupes */}
                    <button
                      onClick={() => setActiveView('groupes')}
                      className={`relative flex items-center gap-2 px-4 py-2.5 rounded-xl text-[13px] font-semibold transition-all duration-200 ${
                        activeView === 'groupes' ? tabActiveClass : tabInactiveClass
                      }`}
                    >
                      <Target className="w-4 h-4" />
                      <span>Groupes</span>
                      <span className={`min-w-[22px] h-[22px] inline-flex items-center justify-center px-1.5 rounded-full text-[11px] font-bold transition ${
                        activeView === 'groupes' ? 'bg-white/20 text-white' : 'bg-slate-100 text-slate-600'
                      }`}>
                        {stats.groupes}
                      </span>
                    </button>

                    {/* Onglet Établissement — visible uniquement pour le prof délégué */}
                    {isDelegueAffectation && (
                      <button
                        onClick={() => setActiveView('etablissement')}
                        className={`relative flex items-center gap-2 px-4 py-2.5 rounded-xl text-[13px] font-semibold transition-all duration-200 ${
                          activeView === 'etablissement' ? tabActiveClass : tabInactiveClass
                        }`}
                      >
                        {/* Pastille pulsante : tant qu'il y a au moins une classe vide (et onglet non actif) */}
                        {activeView !== 'etablissement' && classesVides.length > 0 && (
                          <span className="absolute -top-1 -right-1 flex h-4 w-4">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75" />
                            <span className="relative inline-flex rounded-full h-4 w-4 bg-amber-500 text-white text-[10px] font-bold items-center justify-center ring-2 ring-white">
                              {classesVides.length}
                            </span>
                          </span>
                        )}
                        <Building className="w-4 h-4" />
                        <span>Établissement</span>
                        <span className={`min-w-[22px] h-[22px] inline-flex items-center justify-center px-1.5 rounded-full text-[11px] font-bold transition ${
                          activeView === 'etablissement' ? 'bg-white/20 text-white' : 'bg-slate-100 text-slate-600'
                        }`}>
                          {listClassesEtablissement.length}
                        </span>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>

    {/* Contenu */}
    {!selectedClasseId ? (
      <div className="rounded-2xl p-4 h-fit font-sans">
        {activeView === 'classes' && (
          listClasses.length > 0 && (
            <ListClass classes={listClasses} handleRowClick={handleRowClick} />
          )
        )}
        {activeView === 'groupes' && (
          <ListGroupVueProf groupes={listGroupes} handleRowClick={handleRowClick} />
        )}
        {activeView === 'etablissement' && isDelegueAffectation && (
          <EtablissementView
            classes={listClassesEtablissement}
            professeurs={etablissementData?.professeurs || []}
            classesVides={classesVides}
            onImport={() => navigate('/home/import-etablissement')}
          />
        )}
      </div>
    ) : (
      <div>Vous ne disposez d'aucune classe. Voir l'administrateur du site.</div>
    )}

     </div>
</div>

  {/* CSS animation shine */}
  <style>{`
    @keyframes shine {
      0% { transform: translateX(-100%); }
      100% { transform: translateX(100%); }
    }
  `}</style>
   </div>

    )
}

export default RootProf;